module.exports = __webpack_public_path__ + "img/truck.c937ee4c.svg";